import React from 'react';
import { View, Text } from 'react-native';
import ProductSoldItemProps from 'types/components/ProductSoldItemProps';
import { styles } from 'styles/components/productSoldItem';
import Product from 'types/models/Product';

export default ({ product, isMediumScreen }: ProductSoldItemProps): JSX.Element => {
  const groupArray = (arr: any[], size: number) => {
    const newArray = [];
    for (let i = 0; i < arr.length; i += size) {
      newArray.push(arr.slice(i, i + size));
    }
    return newArray;
  };

  const ClothingSizesStocksList = ({ product }: { product: Product }): JSX.Element => {
    const stocksGrouped = groupArray(product.clothingSizeStocks, 2);

    return (
      <View style={styles.clothingSizeStocksContainer}>
        {stocksGrouped.map((group, index) => (
          <View key={index} style={styles.clothingSizeStockGroupContainer}>
            {group.map((clothingSizeStock, index) => (
              <Text key={index} style={isMediumScreen ? styles.textOrderIdLarge : styles.textOrderIdSmall}>
                {clothingSizeStock.description}: {clothingSizeStock.stock}
              </Text>
            ))}
          </View>
        ))}
      </View>
    );
  };

  return (
    <View style={styles.cardOrderItem}>
      <View style={styles.cardOrderColumn}>
        <Text style={isMediumScreen ? styles.textOrderIdLarge : styles.textOrderIdSmall}>{product.name}</Text>
      </View>
      <View style={styles.cardOrderColumn}>
        {product.isClothing ? (
          <ClothingSizesStocksList product={product} />
        ) : (
          <Text style={isMediumScreen ? styles.textOrderIdLarge : styles.textOrderIdSmall}>{product.stock}</Text>
        )}
      </View>
      <View style={styles.cardOrderColumn}>
        <Text style={isMediumScreen ? styles.textOrderIdLarge : styles.textOrderIdSmall}>{product.amountSold}</Text>
      </View>
    </View>
  );
};
